import styled from "styled-components"
import { Input } from "formik-antd"

export default styled(Input.TextArea)`
  &&& {
    padding: 6px 11px;
    font-size: 16px;
  }
`
